module.exports = __webpack_public_path__ + "static/img/lywg.69592ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/lywg.png
// module id = zEKO
// module chunks = 0